import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const Navbar = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav className="bg-white border-b border-[var(--border-light)] sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Logo Section - Centered */}
        <div className="flex justify-center py-6 border-b border-[var(--border-light)]">
          <Link to="/" className="text-center">
            <img 
              src={`${process.env.PUBLIC_URL || ''}/images/logo.jpeg`}
              alt="Magnificent Diamond Logo" 
              className="h-14 w-auto"
            />
          </Link>
        </div>

        {/* Navigation Links - Horizontal Below Logo */}
        <div className="flex items-center justify-between py-4">
          {/* Desktop Navigation - Horizontal */}
          <div className="hidden md:flex items-center justify-center w-full gap-12">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`navigation-text relative transition-all ${
                  location.pathname === link.path
                    ? 'text-[var(--accent-green-dark)]'
                    : 'text-[var(--text-primary)] hover:text-[var(--accent-green-medium)]'
                }`}
              >
                {link.name}
                {location.pathname === link.path && (
                  <span className="absolute bottom-[-8px] left-0 w-full h-[2px] bg-[var(--accent-green-dark)]"></span>
                )}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden ml-auto"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-[var(--border-light)] py-4">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`navigation-text py-2 ${
                    location.pathname === link.path
                      ? 'text-[var(--accent-green-dark)] font-semibold'
                      : 'text-[var(--text-primary)]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
